import src from "IMAGE";
export default { src, width: 240, height: 60, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AFVrXnhQa1RHRWRWPURjV0RGZVhARWVXPEVnVS9DZFU5AF1sXGpeblJJYm9UTWBuU01jblRQZnBUUlZtUjZFaVIlxr4Vh3u/lp4AAAAASUVORK5CYII="};
